/* icconX help assistant helpers (15 Oct 2026; 16 Oct: live status). IXA_BACK() tells the flows when the team
   (Mon-Sat 10 AM-6 PM IST) next replies, using holidays/festive from #IxaConfig. IXA_ONLINE() is true inside support hours.
   The header status, its dot and the footer clock follow the hours automatically (owner, 16 Oct): "Active now" + green
   inside hours; "Offline · back tomorrow at 10 AM" + grey dot + red clock outside. The footer text itself stays
   "Mon-Sat, 10 AM-6 PM IST" (owner: the "back at" line appears only in the header). Re-checked every minute while open.
   WhatsApp links in the chat open in a new tab with the green chip look. */
(function () {
  var cfgEl = document.getElementById('IxaConfig'); if (!cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent), D = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
  function ist(d) {
    var o = {}; new Intl.DateTimeFormat('en-GB', { timeZone: 'Asia/Kolkata', weekday: 'short', hour: 'numeric', hour12: false, year: 'numeric', month: '2-digit', day: '2-digit' }).formatToParts(d).forEach(function (p) { o[p.type] = p.value; });
    return { day: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'].indexOf(o.weekday), hour: parseInt(o.hour, 10) % 24, date: o.year + '-' + o.month + '-' + o.day };
  }
  function working(t) { return (cfg.holidays || []).indexOf(t.date) < 0 && (cfg.festive || t.day !== 0); }
  window.IXA_BACK = function () {
    var now = Date.now(), t = ist(new Date(now));
    if (working(t) && t.hour >= 10 && t.hour < 18) return '';
    if (working(t) && t.hour < 10) return 'today at 10 AM';
    for (var i = 1; i < 9; i++) { var x = ist(new Date(now + i * 864e5)); if (working(x)) return (i === 1 ? 'tomorrow' : D[x.day]) + ' at 10 AM'; }
    return 'at 10 AM';
  };
  window.IXA_ONLINE = function () { return window.IXA_BACK() === ''; };
  /* Header status + dot + footer clock follow the hours. */
  function refresh() {
    var on = window.IXA_ONLINE(), back = window.IXA_BACK();
    var st = document.getElementById('IxaStatus'), dot = document.getElementById('IxaDot');
    if (st) st.textContent = on ? 'Active now' : 'Offline · back ' + back;
    if (dot) { dot.classList.toggle('is-on', on); dot.classList.toggle('is-off', !on); }
    var h = document.querySelector('.ixa-foot .ixa-foot__h');
    if (h) { h.classList.toggle('is-open', on); h.classList.toggle('is-closed', !on); }
    var modal = document.getElementById('IcconxSupportModal');
    if (modal) modal.classList.toggle('ixa-is-offline', !on);
  }
  refresh(); setInterval(refresh, 60000);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) refresh(); });
  /* WhatsApp links in the chat open in a new tab and get the green chip look. */
  var log = document.getElementById('IxaLog');
  if (log && window.MutationObserver) new MutationObserver(function () {
    log.querySelectorAll('a[href*="wa.me"]:not([target])').forEach(function (a) { a.target = '_blank'; a.rel = 'noopener'; if (!a.closest('.ixa-opts--buttons')) a.className = 'ixa-chip ixa-chip--wa'; });
  }).observe(log, { childList: true, subtree: true });
})();
